export interface TawktoSupportChatInput {
    tawktoScriptUrl: string | null
    tawktoUserName: string | null
    tawktoUserEmail: string | null
    tawktoUserDataHash: string | null
}

export default function useSupportChat() {
    function injectTawktoScript(input: TawktoSupportChatInput): void {
        if (
            !input.tawktoScriptUrl ||
            !input.tawktoUserName ||
            !input.tawktoUserEmail ||
            !input.tawktoUserDataHash
        ) {
            return
        }

        const tawktoScriptContent = `
            <!--Start of Tawk.to Script-->
            <script type="text/javascript">
                var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
                window.Tawk_API.visitor = {
                    name: '${input.tawktoUserName}',
                    email: '${input.tawktoUserEmail}',
                    hash: '${input.tawktoUserDataHash}',
                };
                (function(){
                    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                    s1.async=true;
                    s1.src='${input.tawktoScriptUrl}';
                    s1.charset='UTF-8';
                    s1.setAttribute('crossorigin','*');
                    s0.parentNode.insertBefore(s1,s0);
                })();
            </script>
            <!--End of Tawk.to Script-->
        `

        const documentFragment = document
            .createRange()
            .createContextualFragment(tawktoScriptContent)

        document.head.appendChild(documentFragment)
    }

    return {
        injectTawktoScript,
    }
}
